import { Box, Grid } from "@mui/material";
import NunitoText from "../general/NunitoText";

const MarkTeamBasedHintModal = ({ displayMMMcontent }) => {
  return (
    <Box
      className="popUpModal"
      style={{
        width: 1000,
        minHeight: 310,
        maxHeight: "90vh",
        overflowY: "scroll",
      }}
      justifyContent={"flex-start !important"}
    >
      <NunitoText
        value="Marking Criteria"
        fontSize={30}
        fontWeight={600}
        color="#144A94"
        marginTop={30}
      />
      {displayMMMcontent ? (
        <Grid
          width={"90%"}
          margin={"20px auto 40px"}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"flex-start"}
          gap={"2px"}
        >
          <NunitoText
            value="MMM Scoring System Overview"
            fontSize={22}
            fontWeight={600}
          />
          <NunitoText
            value="Each team will participate in 2 rounds. In each round, there are 5 sets of contest booklets, each with a different level of difficulty. Each booklet contains 4 questions."
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <br />
          <NunitoText
            value="The point system is based on the difficulty level of each set:"
            fontSize={16}
            fontWeight={600}
            align="left"
          />
          <NunitoText
            value="Set 1 (Easiest): 1 point per correct answer"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 2: 2 points per correct answer"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 3: 3 points per correct answer"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 4: 4 points per correct answer"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 5 (Most difficult): 5 points per correct answer"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <br />
          <NunitoText
            value="Maximum Team Score Calculation "
            fontSize={22}
            fontWeight={600}
            align="left"
          />
          <NunitoText
            value="If a team attempts all 5 sets of booklets across 2 rounds:"
            fontSize={16}
            fontWeight={600}
            align="left"
          />
          <NunitoText
            value="Set 1: 4 × 1 = 4 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 2: 4 × 2 = 8 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 3: 4 × 3 = 12 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 4: 4 × 4 = 16 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 5: 4 × 5 = 20 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Total Maximum Score = 60 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <br />
          <NunitoText
            value="For 4-member teams, they may choose to complete only 4 sets of booklets. In this case, the maximum score will be lower, depending on which sets are attempted."
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="However, 4-member teams are allowed to attempt all 5 sets by splitting the work across both rounds."
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <br />
          <NunitoText
            value="For example:"
            fontSize={16}
            fontWeight={600}
            align="left"
          />
          <NunitoText
            value="Round 1: Attempt Sets 1, 2, 3, 4"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Round 2: Since Set 1 is already completed, attempt Sets 2, 3, 4, 5"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="This strategy allows even 4-member teams to aim for the full 60 points."
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <br />
          <NunitoText
            value="Winning Percentage Calculation"
            fontSize={22}
            fontWeight={600}
            align="left"
          />
          <NunitoText
            value="To ensure fairness across teams of different sizes and matchups, the final score is expressed as a winning percentage:"
            fontSize={16}
            fontWeight={600}
            align="left"
          />
          <NunitoText
            value="Winning Percentage = (Total Team Score ÷ Maximum Possible Score) × 100"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <br />
          <NunitoText
            value="Example (4-member team completing 5 sets):"
            fontSize={16}
            fontWeight={600}
            align="left"
          />
          <NunitoText
            value="Set 1: 3 correct answers → 3 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 2: 1 correct answer → 2 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 3: 2 correct answers → 6 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 4: 1 correct answer → 4 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Set 5: 1 correct answer → 5 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <NunitoText
            value="Total Score = 20 points"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
          <br />
          <NunitoText
            value="Winning Percentage = (20 / 60) × 100 = 33.33%"
            fontSize={16}
            fontWeight={400}
            align="left"
          />
        </Grid>
      ) : (
        <Grid
          width={"90%"}
          margin={"20px auto 40px"}
          display={"flex"}
          flexDirection={"column"}
          alignItems={"flex-start"}
          gap={"2px"}
        >
          <NunitoText
            value="Math Warriors (MW) Scoring System"
            fontSize={22}
            fontWeight={600}
          />

          <NunitoText
            value="Each game in MW is scored as follows:"
            fontSize={18}
            fontWeight={600}
          />

          <NunitoText value="Win = 3 points" fontSize={18} fontWeight={400} />
          <NunitoText value="Draw = 1 point" fontSize={18} fontWeight={400} />
          <NunitoText value="Loss = 0 points" fontSize={18} fontWeight={400} />
          <NunitoText
            align="left"
            value="Each team competes in 2 rounds, and each team member plays up to 3 games per round, giving a maximum of 6 games per participant."
            fontSize={18}
            fontWeight={400}
          />
          <br />

          <NunitoText
            value="Maximum Team Score Calculation:"
            fontSize={22}
            fontWeight={600}
          />

          <NunitoText
            value="For 5-member teams:"
            fontSize={18}
            fontWeight={600}
          />

          <NunitoText
            value="2 rounds × 3 games per round × 3 points (win) × 5 members = 90 points max"
            fontSize={18}
            fontWeight={400}
          />

          <NunitoText
            value="For 4-member teams:"
            fontSize={18}
            fontWeight={400}
          />

          <NunitoText
            value="2 rounds × 3 games per round × 3 points (win) × 4 members = 72 points max"
            fontSize={18}
            fontWeight={400}
          />

          <br />

          <NunitoText
            value="Example (5-Member Team):"
            fontSize={18}
            fontWeight={600}
          />

          <NunitoText
            value="Team Member 1: 4 wins, 1 loss, 1 draw → 13 points"
            fontSize={18}
            fontWeight={400}
          />

          <NunitoText
            value="Team Member 2: 6 wins → 18 points"
            fontSize={18}
            fontWeight={400}
          />

          <NunitoText
            value="Team Member 3: 1 win, 5 losses → 3 points"
            fontSize={18}
            fontWeight={400}
          />

          <NunitoText
            value="Team Member 4: 2 wins, 4 draws → 10 points"
            fontSize={18}
            fontWeight={400}
          />

          <NunitoText
            value="Team Member 5: 3 wins, 3 losses → 9 points"
            fontSize={18}
            fontWeight={400}
          />

          <NunitoText
            value="Total Team Score = 53 points"
            fontSize={18}
            fontWeight={400}
          />

          <NunitoText
            value="Winning Percentage = (53 / 90) × 100 = 58.89%"
            fontSize={18}
            fontWeight={400}
          />

          <NunitoText
            value="This winning percentage is used to compare team performance across different team sizes and matchups."
            fontSize={18}
            fontWeight={400}
          />
        </Grid>
      )}
    </Box>
  );
};

export default MarkTeamBasedHintModal;
